module.exports = __webpack_public_path__ + "img/lg_ring_r_e_null_1@2x.3ea45f93.png";